//About page view
import Barba from 'barba.js'
import $ from 'jquery'
import worksMenuToggle from 'modules/worksmenu'
//Progressive from

var Home = Barba.BaseView.extend({
    namespace: "home",
    onEnter: function() {
    },
    onEnterCompleted: function() {
        this._construct()
        $(".js-open-works").click(function(){
            $('body').addClass('js-works-open');
            $('.active').removeClass('active');
            $('.main-menu .js-works-trigger').addClass('active');
            $('html, body').animate({scrollTop : 0},800);
            console.log("open")
        });
        $('a.toggle').click(function(){
          event.preventDefault()
          if($('.toggle-able').hasClass('hidden')){
            $('.toggle-able').removeClass('hidden');
            $(this).hide();
          }
          else{
            // $('.toggle-able').addClass('hidden');
          }
        });
    },
    onLeave: function() {
        this.destroy()
    },
    $el: null,
    _construct: function() {
    },
    destroy: function() {

    }
});
export default Home;



// WEBPACK FOOTER //
// ./source/scripts/modules/barbaviews/home.js